"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shortid = _interopRequireDefault(require("shortid"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _togaButton = _interopRequireWildcard(require("@thinkific/toga-button"));

var _togaModal = _interopRequireDefault(require("@thinkific/toga-modal"));

var _togaCheckbox = _interopRequireDefault(require("@thinkific/toga-checkbox"));

var _togaTypography = require("@thinkific/toga-typography");

var _ColumnSelector = _interopRequireDefault(require("./ColumnSelector.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_ColumnSelector["default"]);

var ColumnSelector = /*#__PURE__*/function (_PureComponent) {
  _inherits(ColumnSelector, _PureComponent);

  var _super = _createSuper(ColumnSelector);

  function ColumnSelector(props) {
    var _this;

    _classCallCheck(this, ColumnSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getFooterButtons", function (closeModal) {
      return /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
        appearance: "secondary",
        onClick: closeModal
      }, "CLOSE");
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (headerName) {
      var _this$props = _this.props,
          handleApply = _this$props.handleApply,
          visibleColumns = _this$props.visibleColumns;
      var config = _this.state.config;
      var newConfig = config.map(function (group) {
        return _objectSpread({}, group, {
          fields: group.fields.map(function (groupItemList) {
            if (groupItemList.headerName === headerName) {
              return _objectSpread({}, groupItemList, {
                visible: groupItemList.visible === undefined ? false : !groupItemList.visible
              });
            }

            return groupItemList;
          })
        });
      });

      if (visibleColumns.includes(headerName)) {
        visibleColumns.splice(visibleColumns.indexOf(headerName), 1);
      } else {
        visibleColumns.push(headerName);
      }

      _this.setState({
        config: newConfig
      });

      handleApply(visibleColumns);
    });

    _defineProperty(_assertThisInitialized(_this), "createHandleToggle", function (headerName) {
      return function () {
        return _this.handleToggle(headerName);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "columnsBlock", function (config) {
      return config.map(function (group) {
        var groupItemList = group.fields.map(function (field) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: cx('group__item', "group__item--".concat(field.headerName)),
            key: field.headerName
          }, /*#__PURE__*/_react["default"].createElement(_togaCheckbox["default"], {
            isChecked: field.visible !== undefined ? field.visible : true,
            isDisabled: field.locked || false,
            labelText: field.displayName,
            onChange: _this.createHandleToggle(field.headerName)
          }));
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: cx('group-wrapper'),
          key: _shortid["default"].generate()
        }, group.name && /*#__PURE__*/_react["default"].createElement(_togaTypography.H6, {
          className: cx('group__name')
        }, group.name), /*#__PURE__*/_react["default"].createElement("ul", {
          className: cx('group__item-list')
        }, groupItemList));
      });
    });

    var _config = _this.props.config;
    _this.state = {
      isOpen: false,
      config: _config
    };
    return _this;
  }

  _createClass(ColumnSelector, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          config = _this$state.config,
          isOpen = _this$state.isOpen;
      var ButtonWithIconLeft = (0, _togaButton.withIcon)({
        position: 'left'
      })(_togaButton["default"]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('column-selector__wrapper')
      }, /*#__PURE__*/_react["default"].createElement(ButtonWithIconLeft, {
        appearance: "knockout",
        className: cx('column-selector__toggle'),
        onClick: this.openModal
      }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        name: "column-select",
        "aria-hidden": true
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('label__wrapper')
      }, "COLUMNS")), /*#__PURE__*/_react["default"].createElement(_togaModal["default"], {
        closeModal: this.closeModal,
        contentLabel: "Column selector modal",
        extraClassNames: cx('modal__container'),
        footer: this.getFooterButtons,
        isOpen: isOpen,
        title: "Choose visible columns"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('group__columns')
      }, this.columnsBlock(config))));
    }
  }]);

  return ColumnSelector;
}(_react.PureComponent);

ColumnSelector.propTypes = {
  config: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      displayName: _propTypes["default"].string,
      headerName: _propTypes["default"].string,
      locked: _propTypes["default"].bool
    })).isRequired,
    name: _propTypes["default"].string
  })),
  handleApply: _propTypes["default"].func.isRequired,
  visibleColumns: _propTypes["default"].array
};
ColumnSelector.defaultProps = {
  config: {
    name: ''
  },
  visibleColumns: []
};
var _default = ColumnSelector;
exports["default"] = _default;